// extracted by mini-css-extract-plugin
export default {"refreshStyle":"DeviceCard_refreshStyle__CMLGU","spinRefresh":"DeviceCard_spinRefresh__w5q7f","refreshStyleLoading":"DeviceCard_refreshStyleLoading__xpt3w"};